<form  id="authorization-form-pg" [formGroup]="formGroup">
    <!-- Code Implementation for Contact Information class="flex flex-col gap-4" -->
         <div class="row mb-3">
        <div class="col-sm-3 mb-3 mb-sm-0">
            <label for="authorization-case-number" class="form-label d-block">Case Number </label>
            <input pInputText type="text" id="authorization-case-number" class="w-100" placeholder="Enter case number"
            formControlName="caseNumber" />
        </div>
    </div>

    <p-panel header="Plaintiff Details" styleClass="panel-skew-heading-with-border">
    <div formArrayName="authorizations">
        <span #stepHeading tabindex="-1" class="sr-only">Step 3: Authorization Information</span>
        <div *ngFor="let authorization of authorizations.controls; let i = index" [formGroupName]="i" [ngClass]="{'mt-5': i > 0}">
            <div class="row mb-3">
                <div class="col-sm-12">
                    <div class="border-bottom-dotted d-flex justify-content-between align-items-center">
                        <h2 #opposingHeaders tabindex="-1" class="contactListNo">
                            <span *ngIf="i<9">Plaintiff Counsel {{ '0'+ (i + 1) }}</span>
                            <span *ngIf="i>=9">Plaintiff Counsel {{ i + 1 }}</span>
                        </h2>
                        <p-button icon="pi pi-trash" styleClass="p-0 mb-1" [link]="true" [text]="true"
                            aria-label="Delete" label="Delete" *ngIf="authorizations && authorizations.length > 1"
                            (onClick)="removeAuthorization(i)" [disabled]="editOrder && !authorization?.value?.isNew"></p-button>
                    </div>
                    <!--  <hr /> -->
                </div>
            </div>
            <div class="row mb-0 mb-lg-3">
                <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                            <label for="authorization-opposing-counsel-attorney-name-{{i}}"
                                class="form-label d-block required-asterisk">Plaintiff Counsel Full Name</label>
                            <input pInputText type="text"
                                id="authorization-opposing-counsel-attorney-name-{{i}}" class="w-100"
                                placeholder="Enter plaintiff counsel full name"
                                formControlName="opposingCounselAttorneyName"
                                [ngClass]="{'ng-invalid ng-dirty' : isError('opposingCounselAttorneyName', authorization)}" />
                            <small id="order-info-ref-num-error"
                                *ngIf="isError('opposingCounselAttorneyName', authorization)" class="error-label">This
                                field is mandatory</small>
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                            <label for="authorization-plaintiff-counsel-bar-number-{{i}}"
                                class="form-label d-block">Bar Number</label>
                            <input pInputText type="text" id="authorization-plaintiff-counsel-bar-number-{{i}}"
                                class="w-100" placeholder="Enter bar number"
                                formControlName="opposingCounselBarNumer"
                                [ngClass]="{'ng-invalid ng-dirty' : isError('opposingCounselBarNumer', authorization)}" />
                            
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                            <label for="authorization-plaintiff-counseal-law-firm-{{i}}"
                                class="form-label d-block required-asterisk">Law Firm</label>
                            <input pInputText type="text" id="authorization-plaintiff-counseal-law-firm-{{i}}"
                                class="w-100" placeholder="Enter law firm"
                                formControlName="opposingCounselFirmName"
                                [ngClass]="{'ng-invalid ng-dirty' : isError('opposingCounselFirmName', authorization)}" />
                            <small id="order-info-ref-num-error"
                                *ngIf="isError('opposingCounselFirmName', authorization)" class="error-label">This field
                                is mandatory</small>
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                            <label for="authorization-plaintiffCounseal-representing-{{i}}"
                                    class="form-label d-block required-asterisk">
                                    Representing - Plaintiff
                            </label>

                            <p-multiselect 
                                [options]="originalSubjectNames" 
                                [showToggleAll]="false" 
                                [filter]="false" 
                                display="chip" 
                                inputId="authorization-plaintiffCounseal-representing-{{i}}" 
                                id="authorization-plaintiffCounseal-representing-{{i}}"
                                styleClass="w-100" 
                                formControlName="recordSubjectName" 
                                optionLabel="name"
                                placeholder="Select representing" 
                                [ngClass]="{'ng-invalid ng-dirty' : isError('recordSubjectName', authorization)}">

                                <!-- Custom footer -->
                                <ng-template pTemplate="footer">
                                <div class="p-2 text-primary cursor-pointer p-multiSelectFooter" (click)="openAddPartyModal('plaintiff',i)">
                                    Don’t see your results? Click here to add more.
                                </div>
                                </ng-template>

                            </p-multiselect>

                            <small id="order-info-ref-num-error" 
                                *ngIf="isError('recordSubjectName', authorization)"
                                class="error-label">
                                This field is mandatory
                            </small>
                        </div>
            </div>
            <div class="row mb-0 mb-lg-3">
                <div class="col-sm-3 mb-3 mb-sm-0">
                    <label for="authorization-street-address-{{i}}" class="form-label d-block">Street Address</label>
                    <input pInputText type="text" id="street-address-{{i}}" class="w-100"
                        placeholder="Enter street address" formControlName="streetAddress" />
                </div>
                <div class="col-sm-3 mb-3 mb-sm-0">
                    <label for="authorization-city-{{i}}" class="form-label d-block">City</label>
                    <input pInputText type="text" id="authorization-city-{{i}}" class="w-100" placeholder="Enter city"
                        formControlName="city" />
                </div>
                <div class="col-sm-3 mb-3 mb-sm-0">
                    <label for="authorization-state-{{i}}" class="form-label d-block">State</label>
                    <p-select formControlName="state" id="authorization-state-{{i}}" [options]="states" optionLabel="name"
                        placeholder="Select state" styleClass="w-100" />
                </div>
                <div class="col-sm-3 mb-3 mb-sm-0">
                    <label for="authorization-zip-{{i}}" class="form-label d-block">Zip</label>
                    <input pInputText type="text" id="authorization-zip-{{i}}" class="w-100" placeholder="Enter zip"
                        formControlName="zip" />
                </div>
            </div>
            <div class="row mb-0 mb-lg-3">
                <div class="col-8 col-md-2 col-lg-2 mb-3 mb-sm-0 pe-1">
                    <label for="authorization-phone-{{i}}" class="form-label d-block">Phone</label>
                    <p-inputmask mask="(999) 999-9999" type="text" id="authorization-phone-{{i}}" class="w-100 phone-inputmask" placeholder="Enter phone"
                        formControlName="phone" autocomplete="new-password"/>
                </div>
                <div class="col-4 col-md-1 col-lg-1 mb-3 mb-sm-0 ps-1">
                    <label for="authorization-phone-extn-{{i}}"
                        class="form-label d-block">Extension</label>
                    <input pInputText type="text" id="authorization-phone-extn-{{i}}" placeholder="Enter"
                        formControlName="extn" class="w-100" />
                </div>
                <div class="col-sm-3 mb-3 mb-sm-0">
                    <label for="authorization-fax-{{i}}" class="form-label d-block">Fax</label>
                    <input pInputText type="text" id="authorization-fax-{{i}}" class="w-100" placeholder="Enter fax"
                        formControlName="fax" />
                </div>
                <div class="col-sm-3 mb-3 mb-sm-0">
                    <label for="authorization-email-{{i}}" class="form-label d-block">Email</label>
                    <input pInputText type="email" id="authorization-email-{{i}}" class="w-100"
                        placeholder="Enter email" formControlName="email" />
                    <small *ngIf="authorization?.get('email')?.hasError('email')" class="error-label">Please
                        enter a valid email address.</small>
                </div>
            </div>
        </div>
    </div>
    <p-button label="Add Plaintiff Counsel" styleClass="px-0" icon="pi pi-plus" (onClick)="addAuthorization()" [link]="true" />
    </p-panel>
    
</form>
<ng-container *ngIf="!showAddPartyModal">
    <app-modal [header]="'Delete Confirmation'" [(showDialog)]="showDeleteModal" [rejectLabel]="'No'"
        [acceptLabel]="'Yes'" (acceptModalClick)="delete()" (rejectModalClick)="showDeleteModal = false">
        <span>Are you sure want to delete this?</span>
</app-modal></ng-container>
<ng-container *ngIf="!showDeleteModal">
    <app-modal [(showDialog)]="showAddPartyModal" [header]="'Add Party'" [acceptLabel]="'Continue'"
        [rejectLabel]="'Cancel'" (acceptModalClick)="saveParty()" (rejectModalClick)="onModalCancel()">
        <div class="add-party-form">
            <div *ngFor="let name of partyNames; let i = index; trackBy: trackByIndex" class="party-input">
                <label *ngIf="i === 0" for="partyName">Party Name <span class="text-danger">*</span></label>
                <input type="text" class="form-control" [(ngModel)]="partyNames[i]" placeholder="Enter party name"
                    [ngClass]="{ 'is-invalid': showValidationErrors && !partyNames[i]?.trim() }" />
                <div class="invalid-feedback" *ngIf="showValidationErrors && !partyNames[i]?.trim()">
                    This field is mandatory
                </div>
            </div>

            <a href="#" class="add-more-link" (click)="addMoreInput($event)">+ Add More</a>
        </div>
    </app-modal>
</ng-container>